import axios from 'axios';
import type { AxiosError, AxiosInstance } from 'axios';
import { captureErrorOnce } from './captureError';

const isReportable = (error: AxiosError) =>
  !error.response || error.response.status >= 500;

const getResponseMessage = (error: AxiosError) => {
  const data = error.response?.data;
  return typeof data === 'object' && data !== null
    ? (data as { message?: string }).message
    : undefined;
};

export const reportApiError = (error: AxiosError) => {
  if (!isReportable(error)) return;

  const { config, response, code } = error;
  const method = config?.method?.toUpperCase();
  const url = config?.url;
  const baseURL = config?.baseURL;
  const fullUrl = baseURL && url ? `${baseURL}${url}` : url;
  const status = response?.status;
  const isNetworkError = !response;

  captureErrorOnce(error, {
    tags: {
      source: 'api',
      type: isNetworkError ? 'network' : 'http_5xx',
      http_method: method,
      http_status: status,
      http_code: code,
      is_network_error: isNetworkError,
    },
    contexts: {
      http: {
        url: fullUrl,
        method,
        status_code: status,
        status_text: response?.statusText,
        response_message: getResponseMessage(error),
      },
    },
  });
};

export const attachSentryErrorReporting = (api: AxiosInstance) => {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!axios.isCancel(error)) reportApiError(error as AxiosError);
      return Promise.reject(error);
    }
  );
};
